import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { TipoProducto } from '@/types/tipoProducto.model';

interface DeleteTipoProductoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  tipoProducto?: TipoProducto;
}

const DeleteTipoProductoModal = ({ isOpen, onClose, onDelete, tipoProducto }: DeleteTipoProductoModalProps) => {
  const handleDelete = async () => {
    if (tipoProducto?.id) {
      await onDelete(tipoProducto.id);
      onClose();
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Eliminar Tipo de Producto</ModalHeader>
            <ModalBody>
              <p>¿Está seguro que desea eliminar el tipo de producto <strong>{tipoProducto?.nombre}</strong>? Esta acción no se puede deshacer.</p>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                variant="light" 
                onPress={onClose}
              >
                Cancelar
              </Button>
              <Button 
                color="primary" 
                onPress={handleDelete}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteTipoProductoModal;